import { createSlice } from "@reduxjs/toolkit";
import {
  getVFees,
  getVFeesGetFilters,
  getVFeesGetFiltersExport,
  getVFeesByClient,
  getVFeesBalance,
  getVFeesBalanceClient,
  getVFeeByNumber,
  getVFeeFindByNumber,
  getVFeesCompany,
  getVFeesFindByID,
  getVFeesDeleted,
  addNewVFee,
  updateVFee,
  deleteVFee,
  lockUnlockVFees,
} from "./thunk";

export const initialState = {
  vfees: [],
  vfeesByClient: [],
  vfeeSpecial: [],
  vfeeFind: [],
  vfeesBalance: [],
  vfeesBalanceClient: [],
  vfeesCompany: [],
  vfeesFindByID: [],
  vfeesDeleted: [],
  vfeesGetFilters: [],
  vfeesGetFiltersExport: [],
  error: {},
  errorGetFilters: null,
  errorGetFiltersExport: null,
  isLoading: false,
  isVFeesSuccess: false,
  isVFeesFailed: false,
  isVFeesLoading: false,
  isVFeesByClientSuccess: false,
  isVFeesByClientFailed: false,
  isVFeesByClientLoading: false,
  isVFeesBalanceSuccess: false,
  isVFeesBalanceFailed: false,
  isVFeesBalanceClientSuccess: false,
  isVFeesBalanceClientFailed: false,
  isVFeesCompanySuccess: false,
  isVFeesCompanyFailed: false,
  isVFeesCompanyLoading: false,
  isVFeeSpecialSuccess: false,
  isVFeeSpecialFail: false,
  isVFeeFindSuccess: false,
  isVFeeFindFail: false,
  isVFeesDeletedSuccess: false,
  isVFeesDeletedFailed: false,
  isVFeesDeletedLoading: false,
  lockMessage: "",
  isLocking: false,
  lockError: null,
  isVFeesGetFiltersSuccess: false,
  isVFeesGetFiltersFailed: false,
  isLoadingGetFilters: false,
  isVFeesGetFiltersExportSuccess: false,
  isVFeesGetFiltersExporFailed: false,
  isLoadingGetFiltersExport: false,
};

const vfeesSlice = createSlice({
  name: "vfee",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    //==================================[ /getVFees/ ]=======================================
    builder.addCase(getVFees.pending, (state) => {
      state.isVFeesLoading = true;
      state.isVFeesSuccess = false;
      state.error = null;
    });
    builder.addCase(getVFees.fulfilled, (state, action) => {
      state.isVFeesLoading = false;
      state.isVFeesSuccess = true;
      state.vfees = action.payload;
    });
    builder.addCase(getVFees.rejected, (state, action) => {
      state.isVFeesLoading = false;
      state.isVFeesSuccess = false;
      state.error = action.error.message;
    });

    builder
      .addCase(getVFeesGetFilters.pending, (state) => {
        state.isLoadingGetFilters = true;
        state.isVFeesGetFiltersFailed = false;
        state.isVFeesGetFiltersSuccess = false;
      })

      .addCase(getVFeesGetFilters.fulfilled, (state, action) => {
        const {
          vfees = [],
          totalStatusCounts = {},
          totalCount = 0,
          countsPerDate = {},
          feeCategoryTotals = [],
          feeVFeeCategoryTotals = {},
        } = action.payload || {};

        state.vfeesGetFilters = vfees;
        state.totalStatusCounts = totalStatusCounts;
        state.totalCount = totalCount;
        state.countsPerDate = countsPerDate;
        state.feeCategoryTotals = feeCategoryTotals;
        state.feeVFeeCategoryTotals = feeVFeeCategoryTotals;

        state.isLoadingGetFilters = false;
        state.isVFeesGetFiltersFailed = false;
        state.isVFeesGetFiltersSuccess = true;
      })

      .addCase(getVFeesGetFilters.rejected, (state, action) => {
        state.errorGetFilters =
          action.payload?.error ||
          action.error?.message ||
          "An unknown error occurred.";
        state.isLoadingGetFilters = false;
        state.isVFeesGetFiltersFailed = true;
        state.isVFeesGetFiltersSuccess = false;
      });

    builder
      .addCase(getVFeesGetFiltersExport.pending, (state) => {
        state.isLoadingGetFiltersExport = true;
        state.isVFeesGetFiltersExportFailed = false;
        state.isVFeesGetFiltersExportSuccess = false;
      })

      .addCase(getVFeesGetFiltersExport.fulfilled, (state, action) => {
        const { vfees = [], totalCount = 0 } = action.payload || {};

        state.vfeesGetFiltersExport = vfees;
        state.totalCount = totalCount;

        state.isLoadingGetFiltersExport = false;
        state.isVFeesGetFiltersExportFailed = false;
        state.isVFeesGetFiltersExportSuccess = true;
      })

      .addCase(getVFeesGetFiltersExport.rejected, (state, action) => {
        state.errorGetFiltersExport =
          action.payload?.error ||
          action.error?.message ||
          "An unknown error occurred.";
        state.isLoadingGetFiltersExport = false;
        state.isVFeesGetFiltersExportFailed = true;
        state.isVFeesGetFiltersExportSuccess = false;
      });

    //====================================================================================
    builder.addCase(getVFeesByClient.pending, (state) => {
      state.isVFeesByClientLoading = true;
      state.isVFeesByClientSuccess = false;
      state.error = null;
    });
    builder.addCase(getVFeesByClient.fulfilled, (state, action) => {
      state.isVFeesByClientLoading = false;
      state.isVFeesByClientSuccess = true;
      state.vfeesByClient = action.payload;
    });
    builder.addCase(getVFeesByClient.rejected, (state, action) => {
      state.isVFeesByClientLoading = false;
      state.isVFeesByClientSuccess = false;
      state.error = action.error.message;
    });

    //==================================[ /getVFeesDeleted/ ]=======================================
    builder.addCase(getVFeesDeleted.pending, (state) => {
      state.isVFeesDeletedLoading = true;
      state.isVFeesDeletedSuccess = false;
      state.error = null;
    });
    builder.addCase(getVFeesDeleted.fulfilled, (state, action) => {
      state.isVFeesDeletedLoading = false;
      state.isVFeesDeletedSuccess = true;
      state.vfeesDeleted = action.payload;
    });
    builder.addCase(getVFeesDeleted.rejected, (state, action) => {
      state.isVFeesDeletedLoading = false;
      state.isVFeesDeletedSuccess = false;
      state.error = action.error.message;
    });

    //==================================[ /getVFeesBalance/ ]=======================================
    builder.addCase(getVFeesBalance.fulfilled, (state, action) => {
      state.vfeesBalance = action.payload;
      state.isVFeesBalanceFailed = false;
      state.isVFeesBalanceSuccess = true;
    });

    builder.addCase(getVFeesBalance.rejected, (state, action) => {
      state.error = action.payload?.error ?? action.error?.message ?? null;
      state.isVFeesBalanceFailed = true;
      state.isVFeesBalanceSuccess = false;
    });

    builder.addCase(getVFeesBalanceClient.fulfilled, (state, action) => {
      state.vfeesBalanceClient = action.payload;
      state.isVFeesBalanceClientFailed = false;
      state.isVFeesBalanceClientSuccess = true;
    });

    builder.addCase(getVFeesBalanceClient.rejected, (state, action) => {
      state.error = action.payload?.error ?? action.error?.message ?? null;
      state.isVFeesBalanceClientFailed = true;
      state.isVFeesBalanceClientSuccess = false;
    });

    builder.addCase(getVFeesCompany.pending, (state) => {
      state.isVFeesCompanyLoading = true;
      state.isVFeesCompanyFailed = false;
      state.isVFeesCompanySuccess = false;
    });

    builder.addCase(getVFeesCompany.fulfilled, (state, action) => {
      state.vfeesCompany = action.payload;
      state.isVFeesCompanyLoading = false;
      state.isVFeesCompanyFailed = false;
      state.isVFeesCompanySuccess = true;
    });

    builder.addCase(getVFeesCompany.rejected, (state, action) => {
      state.isVFeesCompanyLoading = false;
      state.error = action.payload?.error || null;
      state.isVFeesCompanyFailed = true;
      state.isVFeesCompanySuccess = false;
    });

    builder.addCase(getVFeesFindByID.fulfilled, (state, action) => {
      state.vfeesFindByID = action.payload;
      state.isVFeesFindByIDFailed = false;
      state.isVFeesFindByIDSuccess = true;
    });

    builder.addCase(getVFeesFindByID.rejected, (state, action) => {
      state.error = action.payload?.error ?? action.error?.message ?? null;
      state.isVFeesFindByIDFailed = true;
      state.isVFeesFindByIDSuccess = false;
    });

    builder.addCase(getVFeeByNumber.fulfilled, (state, action) => {
      state.vfeeSpecial = action.payload;
      state.isVFeeSpecialFail = false;
      state.isVFeeSpecialSuccess = true;
    });

    builder.addCase(getVFeeByNumber.rejected, (state, action) => {
      state.error = action.payload?.error ?? action.error?.message ?? null;
      state.isVFeeSpecialFail = true;
      state.isVFeeSpecialSuccess = false;
    });

    builder.addCase(getVFeeFindByNumber.fulfilled, (state, action) => {
      state.vfeeFind = action.payload;
      state.isVFeeFindFail = false;
      state.isVFeeFindSuccess = true;
    });

    builder.addCase(getVFeeFindByNumber.rejected, (state, action) => {
      state.error = action.payload?.error ?? action.error?.message ?? null;
      state.isVFeeFindFail = true;
      state.isVFeeFindSuccess = false;
    });

    builder.addCase(addNewVFee.fulfilled, (state, action) => {
      state.vfees.push(action.payload);
      state.isVFeeAdd = true;
      state.isVFeeAddFail = false;
    });

    builder.addCase(addNewVFee.rejected, (state, action) => {
      state.error = action.payload?.error ?? action.error?.message ?? null;
      state.isVFeeAdd = false;
      state.isVFeeAddFail = true;
    });

    builder.addCase(updateVFee.fulfilled, (state, action) => {
      state.vfees = state.vfees.map((vfee) =>
        vfee._id.toString() === action.payload._id.toString()
          ? { ...vfee, ...action.payload }
          : vfee
      );
      state.isVFeeUpdate = true;
      state.isVFeeUpdateFail = false;
    });

    builder.addCase(updateVFee.rejected, (state, action) => {
      state.error = action.payload?.error ?? action.error?.message ?? null;
      state.isVFeeUpdate = false;
      state.isVFeeUpdateFail = true;
    });

    builder.addCase(deleteVFee.fulfilled, (state, action) => {
      //console.log("Deleted ID >>>>>>>", action.payload.id);

      state.vfees = (state.vfees || []).filter(
        (vfee) => vfee._id.toString() !== action.payload.id.toString()
      );

      state.isVFeeDelete = true;
      state.isVFeeDeleteFail = false;
    });

    builder.addCase(deleteVFee.rejected, (state, action) => {
      state.error = action.payload?.error ?? action.error?.message ?? null;
      state.isVFeeDelete = false;
      state.isVFeeDeleteFail = true;
    });

    builder
      .addCase(lockUnlockVFees.pending, (state) => {
        state.isLocking = true;
        state.lockError = null;
      })
      .addCase(lockUnlockVFees.fulfilled, (state, action) => {
        const { beginDate, lastDate, command, message } = action.payload;
        const begin = new Date(beginDate);
        const last = new Date(lastDate);

        // Update islocked for vfees within the date range
        // state.vfees = state.vfees.map((vfee) => {
        //   const vfDate = new Date(vfee.vf_date);
        //   if (vfDate >= begin && vfDate <= last) {
        //     return { ...vfee, islocked: command === "lock" ? "true" : "false" };
        //   }
        //   return vfee;
        // });

        state.vfees = state.vfees.map((vfee) => {
          const vfDate = new Date(vfee.vf_date);
          if (vfDate >= begin && vfDate <= last) {
            return { ...vfee, islocked: command === "lock" ? "true" : "false" };
          }
          return vfee;
        });

        state.lockMessage = message;
        state.isLocking = false;
        state.lockError = null;
      })
      .addCase(lockUnlockVFees.rejected, (state, action) => {
        state.isLocking = false;
        state.lockError = action.payload?.error || "Failed to lock/unlock";
      });
  },
});

export default vfeesSlice.reducer;
